export const isEmptyObject = obj => obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const hasObjProperty = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property);

export const truncate = (text = '', length) => text.length > length ? `${text.slice(0, length)}...` : text